import { render, staticRenderFns } from "./billing-side-by-side.vue?vue&type=template&id=62f570b2"
import script from "./billing-side-by-side.vue?vue&type=script&lang=js"
export * from "./billing-side-by-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports